import type { CSSProperties } from "react";

interface SortHeaderProps {
  label: string;
  active: boolean;
  dir: "asc" | "desc";
  onClick: () => void;
}

const wrapStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  minHeight: 36,
  padding: "0 4px",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontFamily: "var(--font-sans)",
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: 0.6,
  textTransform: "uppercase",
};

/**
 * Sortable column header. Padded to a ~36px tap target (the bare inline sort
 * headers were ~9.5px). Shows a ▲/▼ chevron only when this column is the active
 * sort key; otherwise a dim ↕ to advertise it's sortable.
 */
export function SortHeader({ label, active, dir, onClick }: SortHeaderProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        ...wrapStyle,
        color: active ? "var(--text-primary)" : "var(--text-muted)",
      }}
    >
      <span>{label}</span>
      <span aria-hidden="true" style={{ opacity: active ? 1 : 0.4 }}>
        {active ? (dir === "asc" ? "▲" : "▼") : "↕"}
      </span>
    </button>
  );
}
